<script lang="ts">
    import { spaLink } from "../../actions"
    import InView from "../InView.svelte"
    import MedialibImage from "../MedialibImage.svelte"

    export let newsEntry: ContentEntry
</script>

{#if newsEntry}
    <article class="col news-card">
        <header>
            {#if newsEntry.news?.teaserImage}
                <figure>
                    <InView>
                        <MedialibImage id="{newsEntry.news.teaserImage}" />
                    </InView>
                </figure>
            {/if}
            <div class="badge">
                <!-- Kategorie -->
                <div class="icon">
                    <figure>
                        <img
                            src="/assets/icons/{newsEntry.news?.category || 'news'}.svg"
                            alt="{newsEntry.news?.category}"
                        />
                    </figure>
                </div>
                <div class="text" style="text-transform:capitalize;">
                    {newsEntry.news?.category || "News"}
                </div>
            </div>
        </header>
        <div class="content col-grid grid-bleed gap-l vp-xl hp-xl white-bg">
            <div class="col-12">
                <div class="badge">
                    <span
                        >{new Date(newsEntry.news?.date).toLocaleDateString(undefined, {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                        })}</span
                    >
                </div>
                <h3>{newsEntry.news?.title || ""}</h3>
            </div>
            <div class="col-12 text flex-grow">
                {@html newsEntry.news?.teaserText}
            </div>
            <nav class="vertical tp-0 col">
                <a use:spaLink href="{newsEntry.path}" class="btn-secondary">More details</a>
            </nav>
        </div>
    </article>
{/if}
